// ─── Чистая логика отображения имени/ника/алиаса члена организации ────────────
//
// Вынесено из memberDisplay.jsx, чтобы функцию можно было переиспользовать и
// тестировать без React/JSX (например в resultsExport.js и его юнит-тестах).
// Презентационные компоненты (аватар, чипы, строки) остались в memberDisplay.jsx
// и импортируют getMemberDisplay отсюда.

/**
 * @param {object} m — объект-источник. Поддерживаемые поля:
 *   memberType('REAL'|'GUEST'?), guest(boolean?), userId?, fullName?, firstName?, lastName?,
 *   telegramUserName?, alias?, pendingUsername?, displayName?
 * @returns {{ isGuest: boolean, name: string, aliasTag: string|null,
 *             nick: string|null, awaiting: boolean, initials: string|null }}
 */
export function getMemberDisplay(m = {}) {
  const realName =
    m.fullName ||
    [m.firstName, m.lastName].filter(Boolean).join(' ') ||
    null;

  const isGuest = m.memberType
    ? m.memberType === 'GUEST'
    : (typeof m.guest === 'boolean'
        ? m.guest
        : !(m.telegramUserName || realName || m.userId));

  const aliasMatch = (m.alias || '').match(/@(\w+)/);
  const aliasNick = aliasMatch ? aliasMatch[1] : null;

  if (isGuest) {
    const nick = m.pendingUsername || aliasNick || null;
    const name = m.alias || (nick ? `@${nick}` : null) || m.displayName || 'Без имени';
    const showNick = nick && name !== `@${nick}`;
    const awaiting = !!nick;
    return {
      isGuest: true,
      name,
      aliasTag: null,
      nick: showNick ? nick : null,
      awaiting,
      initials: initialsOf(name),
    };
  }

  const nick = m.telegramUserName || aliasNick || null;
  const name = realName || m.displayName || (nick ? `@${nick}` : 'Без имени');
  const aliasTag = m.alias && m.alias !== `@${nick}` ? m.alias : null;
  const showNick = nick && name !== `@${nick}`;
  return {
    isGuest: false,
    name,
    aliasTag,
    nick: showNick ? nick : null,
    awaiting: false,
    initials: initialsOf(name),
  };
}

/** Инициалы из имени (до 2 букв). Для «@ник»-имени инициалов нет — будет иконка. */
export function initialsOf(name) {
  if (!name || name.startsWith('@')) return null;
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const letters = parts.slice(0, 2).map(p => p[0]).join('');
  return letters ? letters.toUpperCase() : null;
}
